import type { AIProvider } from "../types";
import { OllamaProvider } from "./ollama/OllamaProvider";

export type ProviderId = "ollama";

const PROVIDERS: Record<ProviderId, AIProvider> = {
  ollama: OllamaProvider,
};

/**
 * The single seam a future provider (llama.cpp, LM Studio, a Seufic runtime)
 * registers into. Today there is exactly one, so this always returns it; when
 * a second provider exists, this is where "which one is active" gets decided.
 */
export function getActiveProvider(): AIProvider {
  return PROVIDERS.ollama;
}
